<div #wrapRangeSlider (mousemove)="mouseMoveHandler($event)" class="ui-relative ui-w-full">

  <ol id="areatickmarks" class="ui-flex ui-flex-row ui-justify-between ui-text-primary-gray-70">
    <li *ngFor="let sliderRange of sliderRange" class="ui-flex ui-justify-between ui-pl-sm ui-pr-lg">{{sliderRange}}
    </li>
  </ol>
  <input #rangeInput id="rangeSliderId" [style.backgroundSize]="toBgSizePerc(toPercentOfRange(rangeInput.value, rangeInput.min, rangeInput.max))"
    class="ui-inline-block ui-w-full ui-h-xs ui-outline-none ui-mb-lg" [min]="rangeMin" [max]="rangeMax"
    (input)="onRangeInputChange(rangeInput, rangeOutput)"
    list="areatickmarks" [value]="initialValue" [disabled]="disabled" [class.disabled]="disabled" type="range" />

  <div #wrapRangeOutput
    [style.left]="rangeValueToAbsolutePosOfParentWidth(rangeInput.value, rangeInput.min, rangeInput.max, wrapRangeOutput, wrapRangeSlider,10,10)"
    class="ui-absolute ui-bg-secondary-darkblue ui-text-primary-white ui-rounded-md ui-p-xs ui-h-2xl top-offset-to-arrow-head"
    [class.disabled]="disabled">
    <input #rangeOutput type="number" [disabled]="disabled" class="ui-bg-transparent ui-text-primary-white" [min]="rangeMin" [max]="rangeMax"
    maxlength="3" [value]="initialValue" (input)="onRangeOutputChange(rangeInput, rangeOutput)" />
    <span><label for="rangeOutput">m</label><sup>2</sup></span>
    <i #arrow
      [style.left]="rangeValueToAbsolutePosOfParentWidth(rangeInput.value, rangeInput.min, rangeInput.max, arrow, wrapRangeOutput,12,12)"
      class="ui-absolute ui-left arrow-head"></i>
  </div>
</div>